var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6499 20.6251C21.5841 20.7391 21.4894 20.8338 21.3753 20.8997C21.2613 20.9655 21.1319 21.0001 21.0002 21.0001H3.00021C2.86862 21 2.73938 20.9652 2.62548 20.8993C2.51157 20.8335 2.417 20.7388 2.35127 20.6248C2.28553 20.5108 2.25094 20.3815 2.25098 20.2499C2.25101 20.1183 2.28566 19.9891 2.35146 19.8751C3.77927 17.4067 5.97958 15.6367 8.54739 14.7976C7.27724 14.0415 6.29041 12.8893 5.73845 11.518C5.18648 10.1468 5.09991 8.63224 5.49203 7.20701C5.88414 5.78178 6.73326 4.52467 7.90898 3.62873C9.0847 2.73279 10.522 2.24756 12.0002 2.24756C13.4784 2.24756 14.9157 2.73279 16.0914 3.62873C17.2672 4.52467 18.1163 5.78178 18.5084 7.20701C18.9005 8.63224 18.8139 10.1468 18.262 11.518C17.71 12.8893 16.7232 14.0415 15.453 14.7976C18.0208 15.6367 20.2211 17.4067 21.649 19.8751C21.7149 19.989 21.7497 20.1183 21.7499 20.25C21.7501 20.3816 21.7156 20.511 21.6499 20.6251Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.9b71c6fb444496e0cf9c407d353e04a2.svg";
export { ForwardRef as ReactComponent };